import type { QueryClient } from '@tanstack/react-query'
import type { Address } from 'viem'

import { orpc } from '@/lib/orpc/client'

import { isUserQuery } from './isUserQuery'

export async function invalidateUserEarnPortfolio(
  queryClient: QueryClient,
  userAddress: Address,
  refetchType: 'active' | 'none'
): Promise<void> {
  await Promise.all(
    [
      orpc.user.earnPositions.key({ type: 'query' }),
      orpc.user.vaultPositionHistory.key({ type: 'query' }),
      orpc.user.earnTransactions.key({ type: 'query' })
    ].map(queryKey =>
      queryClient.invalidateQueries(
        { queryKey, predicate: isUserQuery(userAddress), refetchType },
        { throwOnError: true }
      )
    )
  )
}
